/* ============
 * dateFormate Mixin
 * ============
 *
 * Mixins are used to easily expand Vue components.
 * This slot-mixin, will add the hasSlot-method
 * to the specified Vue component.
 */
import { mapGetters } from "vuex";
import moment from "moment-timezone";
import constants from "@/constants/app.properties";

export default {
  /**
   * The methods that the mixin will add.
   */

data() {
    return {
         dateTime: constants.DAY_TIME_FORMAT,
    }
},
  mounted() {	
    this.$store.dispatch("organisation/getOrganisations");	
  },
  computed: {
    ...mapGetters({
        organisation: "organisation/getOrganisations"
    })
  },
  methods: {
    dateFormate(date){	
      var formatedDate = moment.utc(date, "LLLL"); 	
      if(this.organisation.time_zone_location){	
        var timezone = this.organisation.time_zone_location; 	
      }	
      if (formatedDate.clone().tz(timezone)) {
        return formatedDate.clone().tz(timezone).format("LLLL");
      }
    }
  }
};
